module.exports = __webpack_public_path__ + "img/f3777826-e515-4970-bec9-0a032f0f0399.ba6f13a5.jpg";